angular.module("vgresiduos").controller("mtrIntegrationListCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			const params = [];
			if ($stateParams.tab) {
				params.push({ key: "tab", value: $stateParams.tab });
			}
			Vgr.util.redirectSingleton($rootScope, "organizacao/integracoes", params);
		};
	}
]);
